<template>
  <div class="onTheGoSend-container">
    <top-bar :title="'随手拍'" :backImg="top3"></top-bar>
    <div class="onTheGoSend-content">

    </div>
  </div>

</template>

<script>
import topBar from "../top-bar/index";
import top3 from "@/assets/home_new/onTheGo/top3.png";

export default {
  name: "onTheGoSend",
  components: {
    topBar
  },
  data() {
    return {
      route: {},
      top3: top3
    }
  },
  created() {
    this.route = this.$route.query
  },
  mounted() {

  },
  destroyed() {

  },
  methods: {}
}
</script>

<style scoped>
.onTheGoSend-container {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #F1F1F1;
  margin-bottom: 20px;
}

.onTheGoSend-content {
  margin-top: 2.14rem;
  height: 100%;
  padding: 0 20px 0 20px;
}
</style>
